<template>
  <Layout>
    <template #content>
      <div class="mainContent">
        <pageHead device="desktop" page="lottery" :title="Title" :description="$t('store.lottery_description')"/>
        <div class="game-wrap pclottery">
          <h1 class="title"><span class="bg">{{ Title }}</span><q class="dn fg">{{ Title }}</q></h1>
          <div class="game-list one-piece lotto">
            <template v-for="(item, index) in Product(ProductId)">
              <gameMod
                v-model="item.Id"
                :className="`game-group product_${item.Id} ${item.Maintain}`"
                :productId="ProductId"
                :data-text="$t('store.uphold_ing')"
              />
            </template>
          </div>
        </div>
      </div>
    </template> 
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import gameMod from "~/components/desktop/gameMod.vue";
  export default {
    components: {
      Layout,
      pageHead,
      gameMod,
    },
    data() {
      return {
        ProductId: 4,
      };
    },
    computed: {
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        if (this.HasX)
          return '539天天樂' + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
        else
          return this.$t("store.game_lotto") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      ...mapGetters(["Product", "WebSeoName", "ShowPageWebSeoName"])
    },
  };
</script>

<style scoped></style>
